import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { cn } from "../../../Utils/helper";
const ImageSlider = React.memo(
  ({ images = [], onClick, imageHeight, applyImageOverlay, className }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [imageSources, setImageSources] = useState([]);

    useEffect(() => {
      const newSources = images.map((image) => ({
        original: `${process.env.REACT_APP_URL_IMAGE}/${image}`,
        current: `${process.env.REACT_APP_URL_IMAGE}/${image}`,
        hasError: false,
      }));

      if (JSON.stringify(newSources) !== JSON.stringify(imageSources)) {
        setImageSources(newSources);
      }
    }, [images, imageSources]);

    const settings = {
      dots: false,
      infinite: images.length > 1,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      afterChange: (current) => setCurrentSlide(current),
      customPaging: (index) => (
        <div
          className={`h-[5px] rounded-xl transition-all ${
            currentSlide === index ? "w-6 bg-amber-400" : "w-3.5 bg-stone-200"
          }`}
        />
      ),
      // dotsClass: "slick-dots custom-dots",
    };

    const handleImageError = (index) => {
      setImageSources((prev) => {
        if (!prev[index]?.hasError) {
          const newSources = [...prev];
          newSources[index] = {
            ...newSources[index],
            current: "/fallback-image.jpg",
            hasError: true,
          };
          return newSources;
        }
        return prev;
      });
    };

    if (images.length === 0) {
      return (
        <div
          className={cn(
            "flex flex-col items-center justify-center w-full rounded-t-md"
          )}
          onClick={onClick}
        >
          <div className="w-full relative  rounded-t-md">
            <img
              src="https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg"
              alt="No images available"
              className={cn(
                `w-full object-cover  ${imageHeight} rounded-t-md`,
                className
              )}
            />
            {applyImageOverlay && (
              <div className="absolute  bg-[#333333] opacity-50 pointer-events-none rounded-t-md"></div>
            )}
          </div>
        </div>
      );
    }

    if (images.length === 1) {
      const fileName = images[0].split("/").pop() || "Slide 1";

      return (
        <div
          className={`flex flex-col items-center justify-center w-full rounded-t-md`}
          onClick={onClick}
        >
          <div className="w-full relative  ">
            <img
              src={imageSources[0]?.current || "/default-thumbnail.jpg"}
              alt={fileName}
              className={cn(
                `w-full object-cover  ${imageHeight} rounded-t-md`,
                className
              )}
              loading="lazy"
              onError={() => handleImageError(0)}
            />
            {applyImageOverlay && (
              <div className="absolute inset-0 bg-[#333333] opacity-50 pointer-events-none rounded-t-md"></div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={`flex flex-col w-full rounded-t-md`} onClick={onClick}>
        <div className="w-full relative  ">
          <Slider {...settings}>
            {images.map((image, index) => {
              const fileName = image.split("/").pop() || `Slide ${index + 1}`;

              return (
                <div key={index}>
                  <img
                    src={
                      imageSources[index]?.current || "/default-thumbnail.jpg"
                    }
                    alt={fileName}
                    className={cn(
                      `w-full object-cover  ${imageHeight} rounded-t-md`,
                      className
                    )}
                    loading="lazy"
                    onError={() => handleImageError(index)}
                  />
                  {applyImageOverlay && (
                    <div className="absolute inset-0 bg-[#333333] opacity-50 pointer-events-none rounded-t-md"></div>
                  )}
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.images === nextProps.images
);

export default ImageSlider;
